class PrintController {
    /*@ngInject*/
    constructor($translate, $scope) {
        this.$translate = $translate;
        this.$scope = $scope;

        this.model = {
            bagout: null
        };

        this.barcodeOptions =
        {
            format: 'CODE128', lineColor: '#030303', width: 3.7, height: 100, displayValue: false,
            font: 'monospace', textAlign: 'center', textPosition: 'bottom', textMargin: 0, fontSize: 25,
            marginTop: 0, marginBottom: 0
        }

        this.loadCompanyLogo = false;
    }

    $onInit() {
        if (window.opener && window.opener.w && window.opener.w.printData) {
            this.model.bagout = window.opener.w.printData;
            this.print();
        }
    }

    print() {
        setTimeout(() => {
            window.print();
        }, 1500)

        let timeId = setTimeout(() => {
            this.loadCompanyLogo = true;
            this.$scope.$apply();
            clearTimeout(timeId);
        }, 1000);
    }
}
export default PrintController;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/bagouts/print/bagouts.controller.js